/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Steps_BodyInputs */

const en_svc_integration_steps_body = /** @type {(inputs: Svc_Integration_Steps_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integration work depends on the details of the systems involved, so we check those first.`)
};

const lv_svc_integration_steps_body = /** @type {(inputs: Svc_Integration_Steps_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrācijas darbs ir atkarīgs no iesaistīto sistēmu detaļām, tāpēc tās pārbaudām vispirms.`)
};

/**
* | output |
* | --- |
* | "Integration work depends on the details of the systems involved, so we check those first." |
*
* @param {Svc_Integration_Steps_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_steps_body = /** @type {((inputs?: Svc_Integration_Steps_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Steps_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_steps_body(inputs)
	return en_svc_integration_steps_body(inputs)
});